<div class="lookup-select-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <h2>{{ title }}</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon svgIcon="c:x"></mat-icon>
    </button>
  </div>

  <div class="dialog-content flex flex-col">
    <!-- SEARCH -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-icon matPrefix svgIcon="c:search"></mat-icon>
      <input matInput [formControl]="searchControl" placeholder="Search...">
    </mat-form-field>

    <!-- ═══════════════════════════════════════════
         SERVER-SIDE MODE  (WorkOrder: searchFn present)
         ═══════════════════════════════════════════ -->
    @if (data.searchFn) {

      <!-- Skeleton rows while initial fetch or search reset is in flight -->
      @if (isInitialLoading()) {
        <div class="skeleton-list">
          @for (n of [1, 2, 3, 4]; track n) {
            <div class="skeleton-item">
              <div class="skeleton-icon"></div>
              <div class="skeleton-text">
                <div class="skeleton-line skeleton-line--primary"></div>
                <div class="skeleton-line skeleton-line--secondary"></div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Results list with infinite scroll -->
      @if (!isInitialLoading()) {
        @if (filteredOptions.length > 0) {
          <div class="lookup-list-scroll">
            @for (option of filteredOptions; track option.value) {
              <div class="lookup-item"
                [class.selected]="isSelected(option)"
                tabindex="0"
                (click)="selectOption(option)"
                (keyup.enter)="selectOption(option)">
                <div class="flex items-center gap-3 min-w-0">
                  @if (isSelected(option)) {
                    <mat-icon class="text-primary selected-icon" svgIcon="c:check-circle"></mat-icon>
                  }
                  @if (!isSelected(option)) {
                    <mat-icon class="text-gray-300 unselected-icon" svgIcon="c:circle"></mat-icon>
                  }
                  <div class="min-w-0">
                    <div class="lookup-item-label">{{ option.label }}</div>
                    @if (option.subLabel) {
                      <div class="lookup-item-sub-label">{{ option.subLabel }}</div>
                    }
                  </div>
                </div>
                <mat-icon class="text-gray-400" svgIcon="c:chevron-right"></mat-icon>
              </div>
            }
            <!-- Sentinel observed by IntersectionObserver to trigger next page -->
            <div #scrollSentinel class="scroll-sentinel"></div>
            @if (isFetchingMore()) {
              <div class="page-loading-indicator">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
            }
          </div>
        }
        @else {
          <div class="no-data">No records found</div>
        }
      }
    }

    <!-- ═══════════════════════════════════════════
         CLIENT-SIDE MODE  (all other datasources)
         ═══════════════════════════════════════════ -->
    @else {

      <!-- Initial loading spinner (data pre-fetch still in progress) -->
      @if (isLoading) {
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <p class="text-gray-500 mt-3">Loading records...</p>
        </div>
      }

      <!-- Virtual scroll list -->
      @if (!isLoading && filteredOptions.length > 0) {
        <cdk-virtual-scroll-viewport
          itemSize="56"
          class="lookup-list-viewport">
          <div *cdkVirtualFor="let option of filteredOptions; trackBy: trackByValue"
            class="lookup-item"
            [class.selected]="isSelected(option)"
            tabindex="0"
            (click)="selectOption(option)"
            (keyup.enter)="selectOption(option)">
            <div class="flex items-center gap-3 min-w-0">
              @if (isSelected(option)) {
                <mat-icon class="text-primary selected-icon" svgIcon="c:check-circle"></mat-icon>
              }
              @if (!isSelected(option)) {
                <mat-icon class="text-gray-300 unselected-icon" svgIcon="c:circle"></mat-icon>
              }
              <div class="min-w-0">
                <div class="lookup-item-label">{{ option.label }}</div>
                @if (option.subLabel) {
                  <div class="lookup-item-sub-label">{{ option.subLabel }}</div>
                }
              </div>
            </div>
            <mat-icon class="text-gray-400" svgIcon="c:chevron-right"></mat-icon>
          </div>
        </cdk-virtual-scroll-viewport>
      }

      @if (!isLoading && filteredOptions.length === 0) {
        <div class="no-data">No records found</div>
      }
    }
  </div>
</div>
